module.exports = __webpack_public_path__ + "assets/img/ability41.10ccf511.png";